export enum ActionType {
    INIT_WEB3_PENDING = "INIT_WEB3_PENDING",
    INIT_WEB3_SUCCESS = "INIT_WEB3_SUCCESS",
    INIT_WEB3_FAIL = "INIT_WEB3_FAIL",

    INIT_NETWORK_PENDING = "INIT_NETWORK_PENDING",
    INIT_NETWORK_SUCCESS = "INIT_NETWORK_SUCCESS",
    INIT_NETWORK_FAIL = "INIT_NETWORK_FAIL",
    
    INIT_ACCOUNT_PENDING = "INIT_ACCOUNT_PENDING",
    INIT_ACCOUNT_SUCCESS = "INIT_ACCOUNT_SUCCESS",
    INIT_ACCOUNT_FAIL = "INIT_ACCOUNT_FAIL",

    INIT_CONTRACT_PENDING = "INIT_CONTRACT_PENDING",
    INIT_CONTRACT_SUCCESS = "INIT_CONTRACT_SUCCESS",
    INIT_CONTRACT_FAIL = "INIT_CONTRACT_FAIL",

    GET_HAO_BALANCE_PENDING = "GET_HAO_BALANCE_PENDING",
    GET_HAO_BALANCE_SUCCESS = "GET_HAO_BALANCE_SUCCESS",
    GET_HAO_BALANCE_FAIL = "GET_HAO_BALANCE_FAIL",

    GET_POOL_INFO_PENDING = "GET_POOL_INFO_PENDING",
    GET_POOL_INFO_SUCCESS = "GET_POOL_INFO_SUCCESS",
    GET_POOL_INFO_FAIL = "GET_POOL_INFO_FAIL",

    OPEN_STAKING = "OPEN_STAKING",
    CLOSE_STAKING = "CLOSE_STAKING",
    OPEN_UNSTAKING = "OPEN_UNSTAKING",
    CLOSE_UNSTAKING = "CLOSE_UNSTAKING",
    OPEN_CLAIMING = "OPEN_CLAIMING",
    CLOSE_CLAIMING = "CLOSE_CLAIMING",

    SET_HAO_CONTRACT = "SET_HAO_CONTRACT", //TODO: Move to contract reducer
    SET_HAO_BALANCE = "SET_HAO_BALANCE",
    SET_NETWORK_ID = "SET_NETWORK_ID",
    SET_POOL_INFO = "SET_POOL_INFO",
    STAKE_SUCCESS = "STAKE_SUCCESS"

  }
  
  export type Action = {
    type: ActionType,
    payload?: any
  }
  